<template>
  <div>
    <div>
      <label class="form-label font-weight-bold">Select Identity:</label>
      <v-select
        v-model="identitySelected"
        :options="options"
        label="name"
        style="width: 100%"
        class="select-video-input"
        :selectable="isOptionSelectable"
        :clearable="false"
        :searchable="false"
        @input="$emit('on-identity-change', identitySelected)"
      >
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes">
            <feather-icon
              icon="ChevronDownIcon"
              size="13"
            />
          </span>
        </template>
        <template #selected-option="{ logo, name }">
          <img
            class="mr-50"
            style="width: 26px;height: auto"
            :src="logo || require('@/assets/images/pages/campaign/lg-indentity-default.png')"
          >
          <div
            v-b-tooltip.hover.top.v-light.html
            class="d-flex flex-column content-ad-account w-100"
            :title="name ? name : '--'"
          >
            <span
              class="wrap-content"
              style="margin-right: 4px"
            >{{ name }}</span>
          </div>
        </template>
        <template #option="{ logo, name, header }">
          <span
            v-if="!!header"
          >{{ header }}</span>
          <div
            v-else
            class="d-flex align-items-center ml-1"
          >
            <img
              class="mr-50"
              style="width: 26px;height: auto"
              :src="logo || require('@/assets/images/pages/campaign/lg-indentity-default.png')"
            >
            <span>{{ name }}</span>
          </div>
        </template>
      </v-select>
    </div>
    <div class="d-flex justify-content-end align-items-center my-1">
      <b-button
        size="sm"
        variant="outline-primary width-max"
        pill
        @click="handelClearVideo"
      >
        Clear {{ videosSelected.length }} selection
      </b-button>
    </div>
    <div
      ref="videoScrollContainer"
      style="height: calc(100vh - 528px); overflow-y: scroll"
      @scroll="onScroll"
    >
      <div
        v-if="loadingVideo"
        class="d-flex justify-content-center"
      >
        <b-spinner
          variant="secondary"
          small
        />
      </div>
      <div v-else-if="listVideos.length > 0">
        <div class="video-grid">
          <div
            v-for="video in listVideos"
            :key="video.item_id"
            class="video-card"
            :class="{ 'selected': isVideoSelected(video) }"
            @click="toggleVideo(video)"
          >
            <div
              class="video-thumbnail"
              @mouseenter="onHoverStart(video)"
              @mouseleave="onHoverEnd"
            >
              <!-- Small checkbox indicator -->
              <div
                class="select-checkbox"
                :class="{ checked: isVideoSelected(video) }"
              >
                <feather-icon
                  v-if="isVideoSelected(video)"
                  icon="CheckIcon"
                  size="14"
                  class="text-white"
                />
              </div>

              <template v-if="playingVideoId === video.item_id">
                <div
                  class="position-relative"
                  style="width: 100%; height: 100%;"
                >
                  <video
                    :ref="`video-${video.item_id}`"
                    :src="video.video_info.url"
                    autoplay
                    :muted="videoMutedStates[video.item_id] !== false"
                    loop
                    playsinline
                    style="width: 100%; height: 100%; object-fit: cover;"
                  />
                  <feather-icon
                    :icon="videoMutedStates[video.item_id] !== false ? 'VolumeXIcon' : 'Volume2Icon'"
                    size="24"
                    class="video-sound-icon cursor-pointer"
                    @click.stop="toggleVideoSound(video.item_id)"
                  />
                </div>
              </template>
              <template v-else>
                <img
                  :src="video.video_info.poster_url"
                  :alt="video.item_title"
                  class="thumbnail-image"
                >
              </template>
              <!-- Remove full overlay selection -->
            </div>
          </div>
        </div>
        <!-- Load More Loading -->
        <div
          v-if="loadingMore"
          class="d-flex justify-content-center py-3"
        >
          <b-spinner
            variant="secondary"
            small
          />
        </div>
      </div>

      <!-- No Videos State -->
      <div
        v-else-if="listVideos.length === 0"
        class="text-center py-4"
      >
        <b-img
          alt="No account"
          class="img"
          :src="require('@/assets/images/common/no-data-table.svg')"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {
  BButton, BImg, BSpinner, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('campaign')

export default {
  components: {
    BSpinner,
    BImg,
    BButton,
    vSelect,
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  props: {
    allVideos: {
      type: Array,
      default: () => [],
    },

    selectedVideos: {
      type: Array,
      default: () => [],
    },

    selectedVideosTikTok: {
      type: Array,
      default: () => [],
    },

    identityOptions: {
      type: Array,
      default: () => [],
    },

    isTikTokPlacement: {
      type: Boolean,
      default: false,
    },

    selectedIdentity: {
      type: Object,
      default: null,
    },

    loadingVideo: {
      type: Boolean,
      default: false,
    },

    loadingMore: {
      type: Boolean,
      default: false,
    },

    hasMore: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      playingVideoId: null,
      videoMutedStates: {},
      identitySelected: {},
      videosSelected: [],
      savedScrollTop: 0,
      waitingForLoadMore: false,
    }
  },

  computed: {
    ...mapGetters(['loading']),
    options() {
      return [{ header: 'TikTok Account', disabled: true }, ...this.identityOptions.filter(identity => identity.identityType !== 'CUSTOMIZED_USER') || []]
    },

    listVideos() {
      return this.allVideos
    },
  },

  watch: {
    selectedIdentity: {
      handler(val) {
        if (val) {
          this.identitySelected = val
        }
      },
      deep: true,
      immediate: true,
    },

    selectedVideosTikTok: {
      handler(val) {
        if (val) {
          this.videosSelected = val
        }
      },
      deep: true,
      immediate: true,
    },

    // Restore scroll after load-more completes
    loadingMore(newVal, oldVal) {
      if (oldVal === true && newVal === false && this.waitingForLoadMore) {
        this.$nextTick(() => {
          if (this.$refs.videoScrollContainer) {
            this.$refs.videoScrollContainer.scrollTop = this.savedScrollTop
          }
          this.waitingForLoadMore = false
        })
      }
    },
  },

  methods: {
    isOptionSelectable(option) {
      return !option.disabled
    },

    onHoverStart(video) {
      this.playingVideoId = video.item_id
    },

    onHoverEnd() {
      this.playingVideoId = null
    },

    toggleVideoSound(videoId) {
      // Toggle muted state for this video
      this.$set(this.videoMutedStates, videoId, this.videoMutedStates[videoId] === false)
      // Update the video element's muted property
      const videoElement = this.$refs[`video-${videoId}`]
      if (videoElement && videoElement[0]) {
        videoElement[0].muted = this.videoMutedStates[videoId] !== false
      }
    },

    isVideoSelected(video) {
      return this.videosSelected.some(v => v.item_id === video.item_id)
    },

    onScroll(event) {
      const { target } = event
      const { scrollTop, scrollHeight, clientHeight } = target

      // Check if scrolled to bottom (with 100px threshold)
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100

      if (isNearBottom && this.hasMore && !this.loadingMore && !this.loading) {
        // Save current position to restore after items append
        this.savedScrollTop = this.$refs.videoScrollContainer ? this.$refs.videoScrollContainer.scrollTop : 0
        this.waitingForLoadMore = true
        this.$emit('fetchListVideo', true)
      }
    },

    handelClearVideo() {
      this.videosSelected = []
      this.$emit('toggle-video-selection', [])
    },

    toggleVideo(video) {
      const videoWithIdentity = {
        ...video,
        ad_format: video?.ad_format || 'SINGLE_VIDEO',
        identity_authorized_bc_id: this.selectedIdentity.bcId || '',
        identity_id: this.selectedIdentity.value || '',
        identity_type: this.selectedIdentity.identityType || '',
      }
      const index = this.videosSelected.findIndex(v => v.item_id === video.item_id)
      if (index > -1) {
        this.videosSelected.splice(index, 1)
      } else {
        this.videosSelected.push(videoWithIdentity)
      }

      this.$emit('toggle-video-selection', this.videosSelected)
    },
  },
}
</script>
<style lang="scss" scoped>
.select-checkbox {
  z-index: 2; /* Above overlay */
}

.video-sound-icon {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  padding: 4px;
  color: white;
  z-index: 3;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
}
</style>
